import {
  HomeIcon,
  PdfIcon,
  ImageIcon,
  VideosIcon,
  DocumentIcon,
  ExcelIcon,
  DeleteIcon,
  PLusIcon,
  ThreeDotIcon,
  ShareIcon,
 } from "../assets/Icons";

export const HOME_PERMISSION = "REMOTE.ASSIST.HOME";
export const DASHBOARD_PERMISSION = "REMOTE.ASSIST.DASHBOARD.OWN";
export const ACTIVITY_PERMISSION = "REMOTE.ASSIST.MY.ACTIVITY";
export const TEAM_DASHBOARD_PERMISSION = "REMOTE.ASSIST.DASHBOARD.TEAM";
export const WORKFLOW_BUILDER_PERMISSION = "REMOTE.ASSIST.WORKFLOW.BUILDER";
export const REPORT_PERMISSION = "REMOTE.ASSIST.REPORTS";
export const QUESTION_BANK_PERMISSION = "REMOTE.ASSIST.QUESTION.BANK";

export const fileTypeIcons = {
  pdf: { icon: <PdfIcon />, path: "pdf", accept: ".pdf"  },
  pdfs: { icon: <PdfIcon />, path: "pdf", accept: ".pdf" },
  image: { icon: <ImageIcon />, path: "image", accept: ".jpg,.jpeg,.png" },
  images: { icon: <ImageIcon />, path: "image", accept: ".jpg,.jpeg,.png"},
  video: { icon: <VideosIcon />, path: "video",accept: ".mp4" },
  videos: { icon: <VideosIcon />, path: "video", accept: ".mp4" },
  document: { icon: <DocumentIcon />, path: "document", accept: ".doc,.docx,.txt" },
  excel: { icon: <ExcelIcon />, path: "excel", accept: ".xls,.xlsx" },
}